{
    "en": {
        "translation": {
            "Admin password reset": "Admin password reset",
            "Advertisement submitted": "Advertisement submitted",
            "Championship admin confirmed": "Championship admin confirmed",
            "Championship admin request rejected": "Championship admin request rejected",
            "Championship admin request submitted": "Championship admin request submitted",
            "New regatta message": "New regatta message",
            "New regatta protest": "New regatta protest",
            "Please vefiry your email": "Please vefiry your email",
            "Regatta admin confirmed": "Regatta admin confirmed",
            "Regatta admin request rejected": "Regatta admin request rejected",
            "Regatta admin request submitted": "Regatta admin request submitted"
        }
    }
}
